import Repository from '@/repositories/marketing'
const resource = 'analytics/erfm_reports'

export default {
  getErfmInsights(payload,config){
    return Repository.get(`${resource}/erfm_insights.json?`,payload, config)
  },
  getGroupAliases (config) {
    return Repository.get(`${resource}/group_aliases.json`, config)
  },
  saveGroupAliases (payload, config) {
    return Repository.post(`${resource}/group_aliases.json`, payload, config)
  },
  getEngagementAliases(config){
    return Repository.get(`${resource}/engagement_groups.json`, config)
  },
  fetchERFMSettings(config){
    return Repository.get(`${resource}/rfm_settings.json`, config)
  },
  saveERFMSettings(payload,config){
    return Repository.post(`${resource}/rfm_settings.json`, payload, config)
  },
  getGroupChange(payload,config){
    return Repository.get(`${resource}/group_split_metrics.json`,payload, config)
  },
  /**
   * @description Fetch the Contact Distribution data
   * @param {Object} payload
   * @param {*} config
   */
  getDistributionData(payload, config){
    return Repository.get(`${resource}/contact_distribution.json`, payload, config)
  },
  getAveragePerformance(payload, config){
    return Repository.get(`${resource}/average_performance_metrics.json`, payload, config)
  },
  checkBackdatedOrders(payload, config){
    return Repository.get(`${resource}/check_backdated_orders.json`, payload, config)
  },
  refreshBackdatedOrders(payload, config){
    return Repository.get(`${resource}/refresh_backdated_orders.json`, payload, config)
  }
}
